import KeenSlider from 'keen-slider';

const AUTOPLAY_MS = 5000;
const FADE_MS = 1000;
const TAP_MAX_PX = 15;

function easeInOut(time) {
  return time < 0.5
    ? 2 * time * time
    : -1 + (4 - 2 * time) * time;
}

function applySlideFade(slide, portion) {
  const { style } = slide;
  style.opacity = String(portion);
  style.pointerEvents = portion > 0.5 ? 'auto' : 'none';
  style.zIndex = portion > 0 ? '1' : '0';
}

function autoplayPlugin(slider) {
  let autoplayId;

  const start = () => {
    window.clearInterval(autoplayId);
    autoplayId = window.setInterval(() => {
      slider.next();
    }, AUTOPLAY_MS);
  };

  const stop = () => {
    window.clearInterval(autoplayId);
  };

  slider.on('created', start);
  slider.on('dragStarted', stop);
  slider.on('dragEnded', start);
  slider.on('destroyed', stop);
}

function preventClickAfterDrag(root, slider) {
  let dragged = false;

  const onClick = (event) => {
    if (dragged) {
      event.preventDefault();
    }
  };

  slider.on('dragged', () => {
    dragged = true;
  });
  slider.on('dragEnded', () => {
    window.setTimeout(() => {
      dragged = false;
    }, 0);
  });

  root.addEventListener('click', onClick, true);
  slider.on('destroyed', () => {
    root.removeEventListener('click', onClick, true);
  });
}

function followSlideOnTap(root, slider) {
  let startX = 0;
  let startY = 0;
  let startLink = null;

  const onTouchStart = (event) => {
    const touch = event.changedTouches[0];
    startX = touch.clientX;
    startY = touch.clientY;
    startLink = event.target.closest('a');
  };

  const onTouchEnd = (event) => {
    const link = startLink;
    const touch = event.changedTouches[0];
    startLink = null;

    if (!link || !root.contains(link) || !link.href) {
      return;
    }
    if (Math.abs(touch.clientX - startX) > TAP_MAX_PX) {
      return;
    }
    if (Math.abs(touch.clientY - startY) > TAP_MAX_PX) {
      return;
    }

    event.preventDefault();
    window.location.assign(link.href);
  };

  root.addEventListener('touchstart', onTouchStart, { passive: true });
  root.addEventListener('touchend', onTouchEnd);
  slider.on('destroyed', () => {
    root.removeEventListener('touchstart', onTouchStart);
    root.removeEventListener('touchend', onTouchEnd);
  });
}

export default function initSlider(root) {
  if (root.children.length < 2) {
    return;
  }

  const slider = new KeenSlider(
    root,
    {
      loop: true,
      selector: 'a',
      renderMode: 'custom',
      defaultAnimation: {
        duration: FADE_MS,
        easing: easeInOut,
      },
      created() {
        root.classList.add('is-ready');
      },
      detailsChanged(instance) {
        const { details } = instance.track;
        if (!details) {
          return;
        }
        instance.slides.forEach((slide, idx) => {
          applySlideFade(slide, details.slides[idx].portion);
        });
      },
    },
    [autoplayPlugin],
  );

  preventClickAfterDrag(root, slider);
  followSlideOnTap(root, slider);
}
